var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarLoader = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5314 2.19982C34.5251 -0.733263 39.3148 -0.733263 42.3084 2.19982C44.2332 4.08567 47.0038 4.82806 49.6136 4.15724C53.6727 3.11392 57.8207 5.50879 58.9467 9.54572C59.6707 12.1413 61.6989 14.1695 64.2945 14.8935C68.3314 16.0195 70.7263 20.1675 69.683 24.2266C69.0122 26.8364 69.7545 29.607 71.6404 31.5318C74.5735 34.5254 74.5735 39.3152 71.6404 42.3088C69.7545 44.2335 69.0122 47.0041 69.683 49.614C70.7263 53.673 68.3314 57.8211 64.2945 58.9471C61.6989 59.671 59.6707 61.6993 58.9467 64.2949C57.8207 68.3318 53.6727 70.7267 49.6136 69.6833C47.0038 69.0125 44.2332 69.7549 42.3084 71.6408C39.3148 74.5738 34.5251 74.5738 31.5314 71.6408C29.6067 69.7549 26.8361 69.0125 24.2262 69.6833C20.1672 70.7267 16.0191 68.3318 14.8931 64.2949C14.1692 61.6993 12.1409 59.671 9.54535 58.9471C5.50842 57.8211 3.11356 53.673 4.15688 49.614C4.82769 47.0041 4.08531 44.2335 2.19946 42.3088C-0.733629 39.3152 -0.733629 34.5254 2.19946 31.5318C4.08531 29.607 4.82769 26.8364 4.15688 24.2266C3.11355 20.1675 5.50842 16.0195 9.54535 14.8935C12.1409 14.1695 14.1692 12.1413 14.8931 9.54572C16.0191 5.50879 20.1672 3.11392 24.2262 4.15724C26.8361 4.82806 29.6067 4.08567 31.5314 2.19982Z",
    fill: "#E0E0E0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/StarLoader.d434e89f27483a6383dc5e2cf6059f38.svg";